import './plugins';
import './registerServiceWorker';
import './utils';
import Vue from 'vue';
import App from './App.vue';
import i18n from './plugins/i18n';
import store from './store';
import router from './routes';
import sentry from '@/plugins/sentry';
import helper from '@/mixins/helper';

Vue.config.productionTip = false;

Vue.mixin(helper);

new Vue({
  router,
  store,
  i18n,
  sentry,
  helper,
  render: h => h(App),
}).$mount('#app');
